import { FC, ReactNode } from 'react';
import { Row, Col, Typography, Button, Popover } from 'antd';
import { InfoOutlined } from '@ant-design/icons';
const { Title, Text } = Typography;

interface DataViewProps {
  title: string;
  value: string | number;
  titleSpan?: number;
  valueSpan?: number;
  popoverContent?: ReactNode;
  prefix?: string;
  style?: React.CSSProperties;
}

const DataView: FC<DataViewProps> = ({
  title,
  value,
  titleSpan = 12,
  valueSpan = 12,
  popoverContent,
  prefix,
  style,
}) => {
  return (
    <Row gutter={16} style={{ ...style, margin: '0 0 8px' }}>
      <Col span={titleSpan}>
        <Text style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{title}</Text>
      </Col>
      <Col span={valueSpan}>
        <Popover placement="bottom" content={popoverContent}>
          <Title level={5} style={{ margin: '0' }}>
            {prefix ?? prefix} {value}
          </Title>
          {popoverContent && (
            <Button
              style={{ marginLeft: '10px' }}
              size="small"
              icon={<InfoOutlined />}
            ></Button>
          )}
        </Popover>
      </Col>
    </Row>
  );
};

export default DataView;
